import { Text } from '@components/ui';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

export interface SettingsTileProps {
  icon: ReactNode;
  title: string;
  detail: string;
  onClick: () => void;
  ariaLabel?: string;
  trailing?: ReactNode;
}

export const SettingsTile = ({
  icon,
  title,
  detail,
  onClick,
  ariaLabel,
  trailing,
}: SettingsTileProps): JSX.Element => (
  <Box
    component="button"
    type="button"
    onClick={onClick}
    aria-label={ariaLabel ?? title}
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      width: '100%',
      px: 2,
      py: 1.75,
      textAlign: 'left',
      cursor: 'pointer',
      color: 'text.primary',
      bgcolor: 'transparent',
      border: 0,
      borderBottom: 1,
      borderColor: 'divider',
      font: 'inherit',
      '&:last-of-type': { borderBottom: 0 },
      '&:hover': { bgcolor: 'action.hover' },
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        flexShrink: 0,
        borderRadius: 2,
        bgcolor: 'action.hover',
        color: 'text.primary',
      }}
    >
      {icon}
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Text variant="label" sx={{ display: 'block' }}>
        {title}
      </Text>
      <Text variant="caption" tone="muted" sx={{ display: 'block', mt: 0.25 }}>
        {detail}
      </Text>
    </Box>
    {trailing}
  </Box>
);
